import React from "react";
import Fungicide from "./Fungicide";

function page(){
    return(

        <>
        <Fungicide />
        </>

    );
}
export default page;